import Constants from "expo-constants";
import * as Application from "expo-application";

export const getVersion = () => {
  if (Constants.executionEnvironment === "bare") {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require("../package.json").version;
  }
  return Application.nativeApplicationVersion;
};
